import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/user'
import directoryPage from './pages/directoryPage'
import workTypes from './pages/workTypes'
import dictionaries from '@/store/pages/dictionaries'
import filters from '@/store/pages/filters'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  modules: {
    user,
    directoryPage,
    workTypes,
    dictionaries,
    filters
  }
})
